// Raster brand logos for the M&E key-features panel.
//
// The theme's `brandLogos` SVGs are drawn white for the panel's old dark ground
// and vanish on the white one, so that panel uses these instead. Everything
// else - the cover, the original dynamic-at-a-glance - still takes the theme's
// SVGs, which is why these are a separate map rather than a replacement.
//
// Keyed by the hotel's brand key (hotelInfo.brand.key), the same key the theme
// map uses. Sources are the brand masters, downscaled to 400px on the long edge.
import art from "../../../../../assets/clients/rhg/brand-logos/art.png";
import cis from "../../../../../assets/clients/rhg/brand-logos/cis.png";
import pii from "../../../../../assets/clients/rhg/brand-logos/pii.jpg";
import pph from "../../../../../assets/clients/rhg/brand-logos/pph.png";
import prz from "../../../../../assets/clients/rhg/brand-logos/prz.png";
import rad from "../../../../../assets/clients/rhg/brand-logos/rad.jpg";
import rco from "../../../../../assets/clients/rhg/brand-logos/rco.png";
import rdb from "../../../../../assets/clients/rhg/brand-logos/rdb.png";
import rdr from "../../../../../assets/clients/rhg/brand-logos/rdr.jpg";
import ri from "../../../../../assets/clients/rhg/brand-logos/ri.png";

export const AAG_ME_BRAND_LOGOS = {
  art,
  cis,
  pii,
  pph,
  prz,
  rad,
  rco,
  rdb,
  rdr,
  ri,
};
